import { Component, inject } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';

import { environment } from '../environments/environment';

declare const gtag: (type: string, name: string, options: { page_path: string }) => void;

@Component({
  selector: 'mic-root',
  template: '<router-outlet></router-outlet>',
  standalone: false
})
export class AppComponent {
  public router = inject(Router);
  constructor() {
    if (environment.envName !== 'dev') {
      this.router.events.subscribe((event) => {
        if (event instanceof NavigationEnd) {
          gtag('config', environment.analyticsId, { page_path: event.urlAfterRedirects });
        }
      });
    }
  }
}
